import Head from "next/head";
import { redirectTo500 } from "../../utils/utility";
import Image from "next/image";
import ghost from "../../utils/ghost";
import Menu from "../../components/VLSI/menu";
import MobileMenu from "../../components/VLSI/mobileMenu";
import Slider from "../../components/VLSI/slider";
import Services from "../../components/VLSI/services";
import Acheivements from "../../components/VLSI/achievements";
import Tools from "../../components/VLSI/tools";
import Blog from "../../components/VLSI/featuredBlogs";
import Expertise from "../../components/VLSI//expertise";
import Industry from "../../components/VLSI/industry";
import ContentHeader from "../../components/VLSI/header";
import Footer from "../../components/VLSI/footer";
import MobileFooter from "../../components/VLSI/mobileFooter";
import MobileSlider from "../../components/VLSI/mobileSlider";
import { Workflow } from "../../components/VLSI/workflow";

export async function getStaticProps(context) {
  const listPagedData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: "3" },
  });

  if (!listPagedData) {
    return redirectTo500();
  }

  return {
    props: {
      listPaged: listPagedData,
    },
    revalidate: 3600,
  };
}

const Vlsi = (props) => {
  const addBackground = () => {
    let element = document.getElementById("dynamic-menu-image-section");
    element.classList.add("bg-blue-500");
  };
  return (
    <div>
      <Head>
        <title>DSi VLSI | One-stop RTL-to-GDSII Solution</title>
        <meta
          name="description"
          content="More than 20 years of experience in developing large-scale enterprise software solutions both locally and globally. Extensive experience in developing complex e-Service solutions for the government of Bangladesh with nationwide implementation."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>

      <div className="hidden overflow-hidden" id="big-slider">
        <Slider />
      </div>
      <div className="block overflow-hidden" id="small-slider">
        <MobileSlider />
      </div>
      <div className="xl:border-t xl:border-blue-500">
        <ContentHeader bigTitle="SERVICES" title="Our Services" />
        <Services />
      </div>

      <div className="border-t border-blue-500" id="achievements">
        <ContentHeader bigTitle="ACHIEVEMENTS" title="Recent Achievements" />
        <Acheivements />
      </div>

      <div id="languages">
        <Expertise />
      </div>
      <Workflow />
      <div
        id="tools"
        className="bg-blue-500 border-y bg-opacity-5 border-blue-500 pb-7 lg:pb-10 xl:pb-28"
      >
        <ContentHeader bigTitle="TOOLS" title="Tools We Use" />
        <Tools />
      </div>

      <div id="industry">
        <Industry />
      </div>

      <div
        onMouseEnter={addBackground}
        className="border-b border-blue-500 bg-blue-500 bg-opacity-5"
      >
        <div className="flex lg:w-full items-center p-8 lg:py-10 lg:px-28">
          <div className="flex flex-col gap-2 lg:gap-10 w-full">
            <span className="font-headline font-extrabold text-3xl md:text-5xl mb-2 md:mb-0">
              Development Partner
            </span>
            <div className=" flex gap-2 items-center justify-center max-w-6xl mx-auto">
              <div className="w-full" >
                <img
                  alt="vlsi globe"
                  src="/images/VLSI/landing/partner3.png"
                  className="max-w-full"
                />
              </div>

              <div className="w-full">
                <img
                  alt="vlsi globe"
                  src="/images/VLSI/landing/partner1.png"
                  className=" max-w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white w-full py-10 sm:py-20 ">
        <div className="grid  ">
          <div className="" id="blog">
            <ContentHeader bigTitle="BLOG" title="Latest words and thoughts" />
            <div className=" max-w-screen-xl mx-auto">
              <Blog how={props.listPaged.posts} path="/blogs/" />
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-5 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default Vlsi;
